module.exports = __webpack_public_path__ + "static/media/api.e9425145.png";